import ProfileAvatar from '../../components/common/ProfileAvatar';

function SidebarIcon({ name, active }) {
  const color = active ? 'text-[#9369CC]' : 'text-[#666666]';

  const icons = {
    profile: (
      <svg className={`h-5 w-5 ${color}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
      </svg>
    ),
    plan: (
      <svg className={`h-5 w-5 ${color}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
      </svg>
    ),
    progress: (
      <svg className={`h-5 w-5 ${color}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    ),
    favorite: (
      <svg className={`h-5 w-5 ${color}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
      </svg>
    ),
    help: (
      <svg className={`h-5 w-5 ${color}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
      </svg>
    ),
    logout: (
      <svg className="h-5 w-5 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
      </svg>
    ),
  };

  return icons[name] || null;
}

const SIDEBAR_ITEMS = [
  { id: 'profile', label: 'My Profile', icon: 'profile' },
  { id: 'plan', label: 'Plan & Subscription', icon: 'plan' },
  { id: 'progress', label: 'My Learning progress', icon: 'progress' },
  { id: 'favorite', label: 'My Favorite', icon: 'favorite' },
  { id: 'help', label: 'Help & support', icon: 'help' },
];

function ProfileSidebar({ userName, userPhone, avatarUrl, activeItem, onNavigate, onLogout }) {
  return (
    <aside className="flex h-full flex-col bg-gradient-to-t from-[#FFFFFF]/0 to-[#FFFFFF] py-6 pl-24 pr-10">
      <div className="flex items-center gap-3 border-b border-gray-100 pb-5">
        <ProfileAvatar
          src={avatarUrl}
          alt={userName}
          className="h-[80px] w-[80px] rounded-full object-cover ring-2 ring-[#EFE8FF]"
          iconClassName="h-9 w-9 text-white"
        />
        <div>
          <p className="text-[20px] font-medium text-[#000000]">{userName}</p>
          <p className="text-base mt-2 font-normal text-[#666666]">{userPhone}</p>
        </div>
      </div>

      <nav className="mt-5 flex-1 space-y-3">
        {SIDEBAR_ITEMS.map((item) => {
          const active = activeItem === item.id;

          return (
            <button
              key={item.id}
              type="button"
              onClick={() => onNavigate?.(item.id)}
              className={`relative flex w-full items-center gap-3 rounded-r-lg py-3 pl-4 pr-3 text-left text-base font-medium transition ${
                active ? 'bg-[#F7F2FF] text-[#9369CC]' : 'text-[#1B1B1B] hover:bg-gray-50'
              }`}
            >
              {active && (
                <span className="absolute left-0 top-1/2 h-8 w-1 -translate-y-1/2 rounded-r-full bg-[#9369CC]" />
              )}
              <SidebarIcon name={item.icon} active={active} />
              {item.label}
            </button>
          );
        })}
              <button
        type="button"
        onClick={onLogout}
        className=" flex w-full items-center gap-3 rounded-lg px-4 py-3 text-left text-base font-semibold text-red-500 transition hover:bg-red-50"
      >
        <SidebarIcon name="logout" />
        Log Out
      </button>
      </nav>


    </aside>
  );
}

export default ProfileSidebar;
